<template>
    <div>
        <button class="bg-tc-orange-1 rounded-full text-white text-center text-20 px-4 py-1 w-full cursor-pointer h-45px">
            <slot></slot>
        </button>
    </div>
</template>

<script>
export default {
    name: 'Redbtn',
};
</script>

<style lang="scss" scoped>

</style>
